export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/reason/broker',
		name: 'NbuReasonBroker',
		title: {
			single: 'NbuReasonBroker',
			plural: 'NbuReasonBrokers'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "101",
				"code": null,
				"name": "Виключення страхового посередника з Реєстру страхових посередників",
				"caption": "Виключення страхового посередника з Реєстру страхових посередників",
				"isBlocked": false
			},
			{
				"id": "100",
				"code": null,
				"name": "Включення страхового посередника до Реєстру страхових посередників",
				"caption": "Включення страхового посередника до Реєстру страхових посередників",
				"isBlocked": false
			},
			{
				"id": "102",
				"code": null,
				"name": "Для внесення змін до інформації, яка міститься в Реєстрі страхових посередників",
				"caption": "Для внесення змін до інформації, яка міститься в Реєстрі страхових посередників",
				"isBlocked": false
			}
		],
	},
}
